import { render } from "./yeyResourceHome.vue?vue&type=template&id=fda78fb0"
import script from "./yeyResourceHome.vue?vue&type=script&lang=js"
export * from "./yeyResourceHome.vue?vue&type=script&lang=js"

import "./yeyResourceHome.vue?vue&type=style&index=0&id=fda78fb0&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__